import axios from "axios";
import { Message, MessageBox } from "element-ui";
import store from "@/store";
import { getToken } from "@/utils/auth";

// 创建axios实例
const service = axios.create({
  baseURL:'/api',
  // baseURL: process.env.VUE_APP_BASE_API, // api的base_url
  timeout: 600000 // 请求超时时间
});

// request拦截器
service.interceptors.request.use(
  config => {
    const token = getToken();
    if (token) {
      config.headers["HSM-AUTH"] = token; // 让每个请求携带自定义token 请根据实际情况自行修改
    }
    if (config.method === "post" || config.method === "POST") {
      config.headers["Content-Type"] =
        config.headers["Content-Type"] || "application/x-www-form-urlencoded";
      // config.headers["Accept"] =
      //   config.headers["Accept"] || "application/x-www-form-urlencoded";
    }
    config.headers["Cache-Control"] = "no-cache";
    return config;
  },
  error => {
    // Do something with request error
    console.log(error); // for debug
    return error;
    // Promise.reject(error);
  }
);

// respone拦截器
service.interceptors.response.use(
  response => {
    /**
     * code为非20000是抛错 可结合自己业务进行修改
     */
    const res = response.data;
    if (res instanceof Blob) {
      console.log("returnValue 是 Blob 类型");
      return res;
    }
    /**
     * 100：业务处理成功
     * >100：业务处理异常
     */
    if (![100].includes(res.bizcode)) {
      Message({
        message: res.msg,
        type: "error",
        duration: 3 * 1000
      });

      // 201:无效token;
      if (res.bizcode === 201 && [200, 201].includes(res.errcode)) {
        setTimeout(() => {
          store.dispatch("FedLogOut").then(() => {
            location.reload(); // 为了重新实例化vue-router对象 避免bug
          });
        }, 3000);
      }
      // 验证码不正确
      if (![0, -2].includes(res.bizcode)) {
        return response.data;
      }
      return Promise.reject("error");
    } else {
      return response.data;
    }
  },
  error => {
    let msg = "系统异常，请稍后再试";
    if (error.response && error.response.data && error.response.msg) {
      msg = error.response.msg;
    }
    Message({
      message: msg,
      type: "error",
      duration: 5 * 1000
    });
    return Promise.reject("error");
  }
);

export default service;
